import React from 'react';
import { Box, Chip } from '@mui/material';
import { Groups } from '@mui/icons-material';

const SemiCircularProgress = ({
    value = 0,
    color = '#1976d2',
    size = 120,
    stroke = 6
}) => {
    const radius = size / 2;
    const normalizedRadius = radius - stroke / 2;
    const width = size + stroke;
    const height = radius + stroke;

    const circumference = Math.PI * normalizedRadius;
    const strokeDashoffset = circumference - (value / 100) * circumference;

    return (
        <Box
            position="relative"
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{ width }}
        >
            <svg
                width={width}
                height={height}
                viewBox={`0 0 ${width} ${height}`}
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'block' }}
            >
                {/* background arc (rainbow style, top half) */}
                <path
                    d={`
            M ${stroke / 2},${radius}
            A ${normalizedRadius},${normalizedRadius} 0 0 1 ${width - stroke / 2},${radius}
          `}
                    fill="transparent"
                    stroke="#e0e0e0"
                    strokeWidth={stroke}
                    strokeLinecap="round"
                />

                {/* progress arc */}
                <path
                    d={`
            M ${stroke / 2},${radius}
            A ${normalizedRadius},${normalizedRadius} 0 0 1 ${width - stroke / 2},${radius}
          `}
                    fill="transparent"
                    stroke={color}
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                />
            </svg>

            {/* Chip above the arc */}
            <Chip
                size="small"
                label={`${value}%`}
                sx={{
                    position: 'absolute',
                    top: -10,
                    backgroundColor: color,
                    color: 'white',
                    fontWeight: 600
                }}
            />

            {/* Icon centered below the arc */}
            <Box
                position="absolute"
                top="0%" // adjust this to raise/lower the icon
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Groups sx={{ fontSize: Math.round(radius * 1.4), color }} />
            </Box>
        </Box>
    );
};

export default SemiCircularProgress;
